<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <field-selector ref="fieldSelector" class="w-full" v-model="fieldId" @select="onChangeField"/>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div>
        <field-selector ref="fieldSelector" class="w-full xl:w-48" v-model="fieldId" @select="onChangeField"/>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchSelectField",
  components: {
    SearchFilterItem,
    FieldSelector,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "사업장명",
      type: String,
    },
    value: Object,
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'fId': '',
          'fName': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      const { fieldId, fieldName } = value;
      this.fieldId = fieldId;
      this.fieldName = fieldName;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : {fieldId: '', fieldName: ''};
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const fieldId = query[_query_keys[0]];
      const fieldName = query[_query_keys[1]];
      const data = {
        fieldId: fieldId || defaultValue.fieldId,
        fieldName: fieldName || defaultValue.fieldName,
      }
      return data;
    },
    gridTemplateColumns () {
      return this.options && this.options['gridTemplateColumns'] ? this.options['gridTemplateColumns'] : 'auto auto';
    }
  },
  data() {
    return {
      fieldId: "",
      fieldName: "",
    };
  },
  created() {
    this.fieldId = this.initData.fieldId;
    this.fieldName = this.initData.fieldName;
    this.change({
      fieldId: this.fieldId,
      fieldName: this.fieldName,
    })
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onChangeField (field) {
      if (field) {
        this.fieldId = field.id;
        this.fieldName = field.field_name;
      }
      this.change({
        fieldId: field.id,
        fieldName: field.field_name,
      })
      this.$nextTick(() => {
        this.$refs.fieldSelector.initSetField();
      })
    },
    onClickFilterRemove () {
      this.fieldId = '';
      this.fieldName = '';
      this.change({
        fieldId: this.fieldId,
        fieldName: this.fieldName,
      })
      this.$nextTick(() => {
        this.$refs.fieldSelector.initSetField();
      })
    }
  },
};
</script>
